import React from 'react';
import Layout from '../../layout';
import EsperManageSectionOne from '../../components/Esper/Manage/ManageSectionOne';
import RemoteDiagnostics from '../../components/Esper/Manage/RemoteDiagnostics';
import EsperManageFeatures from '../../components/Esper/Manage/EsperManageFeatures';
import EsperManageSections from '../../components/Esper/Manage/EsperManageSections';
import EsperBenefits from '../../components/Esper/Manage/EsperBenefits';
import ManageOG from '../../assets/v2/manage/group-41@3x.png';
import messages from '../../i18n/en';

export default (props: any) => (
  <Layout
    ogImage={ManageOG}
    location={props.location}
    title={
      'Go Beyond Your Traditional MDM Platforms. Move to Android DevOps | Future of MDM'
    }
    messages={messages}
    description={`Esper's DevOps platform is the future of MDM for Android Enterprise Deployments. Discover intelligent features for remote management and device monitoring.`}
    keywords={`Remote Management, Future of MDM,Mobility management,Device Monitoring,Android Enterprise Deployment,Android DevOps`}
    className="first-page"
  >
    <EsperManageSectionOne />
    <EsperManageFeatures />
    <EsperManageSections />
    <RemoteDiagnostics />
    <EsperBenefits />
  </Layout>
);
